import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Card, CardBody, CardHeader, Label, Input, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { api } from "../../config";
import { fetchComAuth, fetchComAuthJson } from '../../common/api';
import MapaMemoizado from "./MapaCadastroFeira";
import Select from "react-select";

const TelaMapaUpload = ({ feiraId, editando }) => {
  const [termoBusca, setTermoBusca] = useState("");
  const fileInputFundoRef = useRef(null);
  
  const [showConfirmMapaModal, setShowConfirmMapaModal] = useState(false);
  const [novoMapaPendente, setNovoMapaPendente] = useState(null); // { mapName, paths, width, height }
  const [componentesPerdidosPendentes, setComponentesPerdidosPendentes] = useState([]);
  const [estandesComVinculo, setEstandesComVinculo] = useState([]);
  const [componentesPerdidosSemCadastro, setComponentesPerdidosSemCadastro] = useState([]);
  const [showConfirmResetModal, setShowConfirmResetModal] = useState(false);
  
  const [componentesMantidos, setComponentesMantidos] = useState([]);
  const [componentesNovos, setComponentesNovos] = useState([]);
  const [modoEdicaoMapa, setModoEdicaoMapa] = useState(false);
  const [estandeEditando, setEstandeEditando] = useState(null);
  const [estandeSelecionado, setEstandeSelecionado] = useState(null);
  const [componentIdEditando, setComponentIdEditando] = useState(null);
  const [tiposEspacoOptions, setTiposEspacoOptions] = useState([]);
  const [tiposEspacoFeira, setTiposEspacoFeira] = useState([]);
  
  const [resumoItens, setResumoItens] = useState([]);
  const [estandesCadastrados, setEstandesCadastrados] = useState([]);
  const [mapData, setMapData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  // const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [deletingMap, setDeletingMap] = useState(false);
  const [fundoUrl, setFundoUrl] = useState('/fundo-mapa.png');
  const [fundo, setFundo] = useState('');
  const [fundoBase64, setFundoBase64] = useState('');
  const [editandoMapa, setEditandoMapa] = useState(false);
  const [selectedComponents, setSelectedComponents] = useState([]);
  const [componentHashes, setComponentHashes] = useState({});
  const [lastSelected, setLastSelected] = useState(null);
  
  const [modoEdicaoTexto, setModoEdicaoTexto] = useState(false);
  const [estandeTextoEditando, setEstandeTextoEditando] = useState(null); // Armazena o objeto do estande
  const [posicaoTextoTemporaria, setPosicaoTextoTemporaria] = useState({ x: 0, y: 0 });
  const [posicaoTextoOriginal, setPosicaoTextoOriginal] = useState({ x: 0, y: 0 });

  const [pathsRendered, setPathsRendered] = useState(false);
  const mapaRegistradoRef = useRef(false);
  const [formData, setFormData] = useState({
      tipo_espaco_id: '',
      pavilhao_id: '',
      estacionamento_id: '',
      tem_estacionamento: false,
      altura: "",
      largura: "",
      altura_minima: "",
      altura_maxima: "",
      metragem_bonificada: "",
      valor_m2: "", // Novo campo
      imagens: [],
      tags: [],
      observacao: "",
      comprimento: "",
      valor_total: "",
      area: "",
      kva_id: "",
      valor_kva: "",
      feira_id: feiraId 
    });

  const svgRef = useRef(null);
  const mapContainerRef = useRef(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef(null);
  const [selectedExpositor, setSelectedExpositor] = useState([]);
  const [selectedEstande, setSelectedEstande] = useState([]);

  const [EstandeOpcoes, setEstandeOpcoes] = useState([]);

  const [ExpositorOpcoes, setExpositorOpcoes] = useState([]);
  const [expositor, setExpositor] = useState([]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // 1. Bloqueador radical para todos os eventos problemáticos
    const blockEverything = (e) => {
      if (e.touches?.length > 1) { // Se for um gesto de pinça
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };

    // 2. Eventos a serem bloqueados
    const events = [
      'touchstart', 'touchmove', 'touchend', 'touchcancel',
      'wheel', 'mousewheel', 'gesturestart', 'gesturechange'
    ];

    // 3. Adiciona os listeners com capture=true (importante!)
    events.forEach(event => {
      container.addEventListener(event, blockEverything, {
        passive: false,
        capture: true // Captura na fase de bubbling
      });
    });

    return () => {
      events.forEach(event => {
        container.removeEventListener(event, blockEverything, { capture: true });
      });
    };
  }, []);

  useEffect(() => {
    const updateSize = () => {
      if (mapContainerRef.current) {
        setContainerSize({
          width: mapContainerRef.current.offsetWidth,
          height: mapContainerRef.current.offsetHeight
        });
      }
    };

    updateSize();
    const resizeObserver = new ResizeObserver(updateSize);
    if (mapContainerRef.current) {
      resizeObserver.observe(mapContainerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
  const handleResize = () => {
    if (mapInstance.current) {
      setTimeout(() => {
        mapInstance.current.updateSize();
      }, 100);
    }
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  const handleDeleteMap = async () => {
    try {
      setDeletingMap(true);
      const response = await fetchComAuth(`${api.API_URL}/feira/mapa/${feiraId}`, {
        method: "DELETE",
      });

      const json = await response.json();
      
      if (json.success) {
        toast.success("Mapa excluído com sucesso!");
        
        // Limpar todos os estados relacionados ao mapa
        setMapData(null);
        setEstandesCadastrados([]);
        setComponentesMantidos([]);
        setComponentesNovos([]);
        setComponentHashes({});
        setLastSelected(null);
        setFundoUrl("");
        setFundo(null);
        
        mapaRegistradoRef.current = false;
        
        // Limpar a instância do mapa
        if (mapInstance.current) {
          
          try {
            mapInstance.current.destroy();
            mapInstance.current = null;
            
          } catch (err) {
            console.warn("Erro ao destruir instância do mapa:", err);
          }
        }
        
        // Forçar atualização do container
        setContainerSize(prev => ({ ...prev }));
        
        // Desativar modo de edição
        setModoEdicaoMapa(false);
        // setTimeout(() => window.location.reload(), 1000);
      
      } else {
        toast.error("Erro ao excluir mapa.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erro na comunicação com o servidor.");
    } finally {
      setDeletingMap(false);
      setShowConfirmDeleteModal(false);
    }
  };

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        setContainerSize({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight
        });
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    if (tiposEspacoFeira.length > 0 && !formData.tipo_espaco_id) {
      setFormData(prev => ({
        ...prev,
        tipo_espaco_id: tiposEspacoFeira[0]?.tipo_espaco_id?.toString() || ''
      }));
    }
  }, [tiposEspacoFeira]);

  useEffect(() => {
    const carregarDadosTiposEspaco = async () => {
      try {
        const responseTipos = await fetchComAuth(`${api.API_URL}/tipo-espaco`, {
          method: 'GET'
        });

        const dataTiposEspaco = await responseTipos.json();
  
        setTiposEspacoOptions(dataTiposEspaco.data);
  
        if (feiraId && editando) {
          const responseFeiraTiposEspaco = await fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`, {
            method: 'GET'
          });

          const dataFeiraTiposEspaco = await responseFeiraTiposEspaco.json();
          setTiposEspacoFeira(dataFeiraTiposEspaco.data);
        }
      } catch (err) {
        console.error("Erro ao carregar tipos de espaço:", err);
      }
    };
  
    carregarDadosTiposEspaco();
  }, [feiraId, editando]);
  
  const confirmarSalvarNovoMapa = async () => {
    if (!novoMapaPendente) return;
    // Chama a função unificada passando o estado pendente
    persistirMapaNoBanco(novoMapaPendente, componentesPerdidosPendentes);
  };

  const limparCamposEspecificos = () => {
    setEstandeEditando(null);
    setEstandeSelecionado(null);
    setSelectedEstande(null);
    setSelectedExpositor(null);

    setFormData(prev => ({
      ...prev,
      id: null,
      expositor: [],
      // tipo_espaco_id: ultimoTipoGravado,
      imagens: [],
      tags: [],
      valor_m2: "",
      valor_total: "",
      largura: "",
      comprimento: "",
      altura: "",
      altura_minima: "",
      altura_maxima: "",
      metragem_bonificada: "",
      observacao: "",
      nome: "",
      area: "",
      pavilhao_id: null,
      estacionamento_id : null
    }));
    setResumoItens([]);
    setShowConfirmResetModal(false);
  };

  const calculateTotalGeral = () => {
    const total = resumoItens.reduce((acc, item) => acc + item.total, 0).toFixed(2);
    return total;
  };

  const manterCampos = () => {
    setFormData(prev => ({
      ...prev,
      tipo_espaco_id: novoTipoEspacoSelecionado || prev.tipo_espaco_id
    }));
    setShowConfirmResetModal(false);
    setNovoTipoEspacoSelecionado(null);
  };
  
  const obterCorDoTipoEspaco = (tipoId) => {
    const tipo = tiposEspacoFeira.find(t => t.tipo_espaco_id === Number(tipoId));
    return tipo?.cor || "#4CAF50"; // cor padrão se não encontrar
  };
  
  const carregarMapaSalvo = async () => {
    if (!feiraId) return;

    try {
      // Buscar o mapa da feira
      const responseMapa = await fetchComAuth(`${api.API_URL}/feira/mapa/${feiraId}`, {
        method: 'GET'
      });
      const data = await responseMapa.json();
      const mapa = data.data?.mapa?.mapa;
      
      if (data.data?.fundoURL) {
        setFundoUrl(data.data.fundoURL);
        setFundoBase64('');
      }

      if (mapa?.mapName && mapa?.paths && mapa?.width && mapa?.height) {
        setMapData({
          mapName: mapa.mapName,
          width: Number(mapa.width),
          height: Number(mapa.height),
          paths: mapa.paths
        });

        const hashMap = {};
        Object.entries(mapa.paths).forEach(([key, value]) => {
          if (value.hash) {
            hashMap[key] = value.hash;
          }
        });
        setComponentHashes(hashMap);

        // Carrega os estandes cadastrados após o mapa ser definido
        const estandes = await loadEstantesCadastrados();
        setEstandesCadastrados(estandes);
 
        const estandesSemMapa = estandes.filter(e => e.component_id === '' && e.hash_path === '');
        
        const opcoesFormatadas = estandesSemMapa.map(est => {
          return {
            value: est.id,
            label: est.nome
          };
        });
        
        setEstandeOpcoes(opcoesFormatadas);

      } else {
        console.error("Mapa incompleto ou inválido", mapa);
        return;
      }

    } catch (err) {
      console.error("Erro ao carregar mapa ou espaços da feira:", err);
    }
  };

  useEffect(() => {
    if (editando) {
      carregarMapaSalvo();
    }
  }, [editando, modoEdicaoMapa]);

  const fetchExpositores = async () => {
    setIsLoading(true);
    try {
      const response = await fetchComAuth(`${api.API_URL}/feiraExpositor/${feiraId}`, {
        method: 'GET'
      });
      const data = await response.json();
      const lista = data.data || [];
      setExpositor(lista);

      // Formata as opções para o componente Select
      const opcoes = lista.map(exp => ({
        value: exp.id,
        label: exp.nome_mapa || exp.nome || exp.nome_fantasia
      }));
      setExpositorOpcoes(opcoes);
      
    } catch (error) {
      console.error("Erro ao buscar expositores:", error);
      toast.error("Erro ao buscar expositores");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (feiraId) {
      fetchExpositores();
    }
  }, [feiraId]);

  // Função reutilizável para persistir o mapa no backend
  const persistirMapaNoBanco = async (dadosMapa, listaPerdidos = []) => {
    const mapa = {
      feira_id: feiraId,
      mapa: {
        mapName: dadosMapa.mapName,
        paths: dadosMapa.paths,
        width: dadosMapa.width,
        height: dadosMapa.height
      },
    };

    const mapaParaSalvar = {
      feira_id: feiraId,
      mapa: mapa,
      altura: dadosMapa.height,
      nome: dadosMapa.mapName,
      quantidade_estandes: Object.keys(dadosMapa.paths).length - 1,
      largura: dadosMapa.width,
      prefix: "",
      fundoUrl: fundoBase64 || "",
      componentes_perdidos: JSON.stringify(listaPerdidos.map((c) => c.component_id))
    };

    try {
      const response = await fetchComAuthJson(`${api.API_URL}/feira/mapa/salvar`, {
        method: "POST",
        body: JSON.stringify(mapaParaSalvar),
      });

      const json = await response.json();
      
      if (json.success) {
        toast.success("Mapa salvo com sucesso!");
        setMapData(dadosMapa); 
        setShowConfirmMapaModal(false);
        setNovoMapaPendente(null);
        setComponentesPerdidosPendentes([]);
        setEstandesComVinculo([]);
        setComponentesPerdidosSemCadastro([]);
        setModoEdicaoMapa(false);
      } else {
        toast.error("Erro ao salvar o novo mapa.");
      }
    } catch (err) {
      console.error("Erro ao salvar o novo mapa:", err);
      toast.error("Falha na comunicação com o servidor.");
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsLoading(true);
    setError(null);
    setSelectedComponents([]);
    
    const formDataUpload = new FormData();
    formDataUpload.append("svg", file);
    formDataUpload.append("prefix", 'area_');
    formDataUpload.append("feira_id", feiraId);

    try {
      // 1. Processa o SVG (Parsing)
      const response = await fetchComAuth(`${api.API_URL}/feira/mapa`, {
        method: "POST",
        body: formDataUpload,
      });

      const json = await response.json();

      if (!json.success) {
        toast.error(json.error || "Falha ao processar o arquivo SVG.");
        return;
      }

      const { result, mapName } = json.data;
      
      // Atualiza estados auxiliares para visualização (opcional se for salvar direto, mas bom manter)
      setComponentesPerdidosPendentes(json.data.perdidos || []);
      setComponentesPerdidosSemCadastro(json.data.perdidos_sem_estande || []);
      setComponentesMantidos(json.data.mantidos || []);
      setComponentesNovos(json.data.novos || []);
      setEstandesComVinculo(json.data.estandesComVinculos || []);
      
      // Prepara objeto do Hash map
      const hashMap = {};
      if (result.paths) {
        Object.entries(result.paths).forEach(([key, value]) => {
          if (value.hash) {
            hashMap[key] = value.hash;
          }
        });
      }
      setComponentHashes(hashMap);

      // Estrutura do novo mapa
      const novoMapa = {
        mapName: mapName,
        paths: result.paths,
        width: result.width,
        height: result.height,
      };
      
      if (json.data.perdidos && json.data.perdidos.length > 0) {
        setNovoMapaPendente(novoMapa);
        setShowConfirmMapaModal(true);
      } else {
        await persistirMapaNoBanco(novoMapa, []);
      }

    } catch (err) {
      console.error("Erro ao processar SVG:", err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (novoMapaPendente) {
    
    }
  }, [novoMapaPendente]);

  const renderEstandeText = (node, estande) => {
    const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
    group.classList.add("estande-label-group");
    group.style.pointerEvents = "none";

    // 1. Posição Padrão: O centro geométrico do estande
    const bbox = node.getBBox();
    let centerX = bbox.x + bbox.width / 2;
    let centerY = bbox.y + bbox.height / 2;

    // 2. Exceção: Verifica se há uma posição salva no banco de dados e a utiliza
    if (estande.label_pos_x != null && estande.label_pos_y != null) {
      centerX = estande.label_pos_x;
      centerY = estande.label_pos_y;
    }

    // 3. Edição ao Vivo: Se estiver editando este estande, sobrepõe com a posição temporária
    if (modoEdicaoTexto && estandeTextoEditando?.id === estande.id) {
      centerX = posicaoTextoTemporaria.x;
      centerY = posicaoTextoTemporaria.y;
    }

    // Função auxiliar para criar elementos de texto
    const createTextElement = (content, y, fontSize, fontWeight = 'normal') => {
      const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
      text.setAttribute("x", centerX);
      text.setAttribute("y", y);
      text.setAttribute("text-anchor", "middle");
      text.setAttribute("font-size", `${fontSize}px`);
      text.setAttribute("font-weight", fontWeight);
      text.setAttribute("fill", "#000");
      text.setAttribute("font-family", "sans-serif");
      text.style.pointerEvents = "none";
      text.textContent = content || '';
      return text;
    };

    let currentYOffset = -8;
    const lineSpacing = 12;

    // 1. Nome do estande (Ex: "A01")
    if (estande.nome) {
        const nomeEstande = createTextElement(estande.nome.toUpperCase(), centerY + currentYOffset, 20, 'bold');
        group.appendChild(nomeEstande);
        currentYOffset += lineSpacing;
    }

    // 2. Área do estande (Ex: "A=100.00m²")
    if (estande.area > 0 && estande.permite_locacao) {
      const area = estande.area + estande.metragem_bonificada ?? 0;
          
      const areaEstande = createTextElement(`A=${parseFloat(area).toFixed(2)}m²`, centerY + currentYOffset, 12);
      group.appendChild(areaEstande);
      currentYOffset += lineSpacing;
    }
    
    // 3. Informações do Expositor (se vendido ou reservado)
    if (estande.status_reserva_id === 2 || estande.status_reserva_id === 3) {
        if (estande.expositor && estande.expositor.length > 0) {
            const expositor = estande.expositor[0];
            const nome = (expositor.nome_mapa ?? expositor.nome.split(' ')[0]).toUpperCase();
            const nomeExpositor = createTextElement(nome, centerY + currentYOffset, 9);
            group.appendChild(nomeExpositor);
            currentYOffset += lineSpacing;
        }
        // 4. Status "RESERVADO"
        if (estande.status_reserva_id === 2) {
            const statusReservado = createTextElement('RESERVADO', centerY + currentYOffset, 10);
            group.appendChild(statusReservado);
        }
    }

    return group;
  };

  const updateSelectedRegionsVisual = (selectedCodes) => {
    if (!svgRef.current) return;
    
    const paths = svgRef.current.querySelectorAll('path[data-code]');
    
    paths.forEach(path => {
      const nodeCode = path.getAttribute('data-code');
      const isSelected = selectedCodes.includes(nodeCode);
      const isRegistered = estandesCadastrados.some(e => e.hash_path === path.getAttribute('data-hash'));
      
      if (isSelected) {
        path.setAttribute("fill", "#FFA500");
        path.setAttribute("stroke", "#FF0000");
        path.setAttribute("stroke-width", "2.5");
      } else {
        if (isRegistered) {
          const estande = estandesCadastrados.find(e => e.hash_path === path.getAttribute('data-hash'));
          path.setAttribute("fill", obterCorDoTipoEspaco(estande.tipo_espaco_id));
        } else {
          path.setAttribute("fill", "#DCDCDC");
        }
        path.setAttribute("stroke", "#333");
        path.setAttribute("stroke-width", "1.5");
      }
    });
  };

    useEffect(() => {
    
      if (!svgRef.current || !mapData?.paths) return;

      const camada = svgRef.current.querySelector('#camada');
      if (!camada) return;

      camada.innerHTML = '';

      Object.entries(mapData.paths).forEach(([setorId, pathData]) => {
          const estandeGrupo = document.createElementNS("http://www.w3.org/2000/svg", "g");
          const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
          const estandeCadastrado = estandesCadastrados?.find(e => e.hash_path === pathData.hash);
          
          let cor = estandeCadastrado ? obterCorDoTipoEspaco(estandeCadastrado.tipo_espaco_id) : "#DCDCDC";

          let opacidade = 1;

          // LÓGICA DE FILTRO/BUSCA
          if (termoBusca.length > 0) {
              const nomeEstande = estandeCadastrado?.nome?.toLowerCase() || "";
              const nomeExpositor = estandeCadastrado?.expositor?.[0]?.nome?.toLowerCase() || "";
              const nomeMapaExpositor = estandeCadastrado?.expositor?.[0]?.nome_mapa?.toLowerCase() || "";
              const termo = termoBusca.toLowerCase();

              const match = nomeEstande.includes(termo) || 
                            nomeExpositor.includes(termo) || 
                            nomeMapaExpositor.includes(termo);

              if (match) {
                  cor = "#FFFF00"; // Amarelo vibrante para o que foi encontrado
                  opacidade = 1;
              } else {
                  opacidade = 0.2; // Esmaece o que não condiz com a busca
              }
          }

          path.setAttribute("fill", cor);
          path.setAttribute("fill-opacity", opacidade);

          path.setAttribute("d", pathData.path);
          //path.setAttribute("fill", cor);
          path.setAttribute("stroke", "#333");
          path.setAttribute("stroke-width", "1.5");
          path.setAttribute("data-hash", pathData.hash);
          path.setAttribute("data-code", setorId);
          path.style.pointerEvents = "auto";
          path.style.cursor = "pointer";

          estandeGrupo.appendChild(path);
          
          camada.appendChild(estandeGrupo);

          if (estandeCadastrado) {
              const labelGroup = renderEstandeText(path, estandeCadastrado);
              estandeGrupo.appendChild(labelGroup);
          }
          
          path.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            const componentId = path.getAttribute('data-code');
            
            if (editandoMapa) {
              // Lógica de seleção para edição
              if (e.ctrlKey || e.metaKey) {
                setSelectedComponents(prev => {
                  const newSelection = prev.includes(componentId) 
                    ? prev.filter(c => c !== componentId)
                    : [...prev, componentId];
                  updateSelectedRegionsVisual(newSelection);
                  return newSelection;
                });
              } else {
                setSelectedComponents([componentId]);
                updateSelectedRegionsVisual([componentId]);
                limparCamposEspecificos();
              }
              setLastSelected(componentId);
            } else {
              const estandeExistente = estandesCadastrados.find(e => e.hash_path === path.getAttribute('data-hash'));
              
              if (estandeExistente) {
                setSelectedEstande({
                  value: estandeExistente.id,
                  label: estandeExistente.nome
                });

                if (estandeExistente.expositor && estandeExistente.expositor.length > 0) {
                  const exp = estandeExistente.expositor[0];
                  setSelectedExpositor({
                    value: exp.id,
                    label: exp.nome_mapa || exp.nome || exp.nome_fantasia
                  });
                } else {
                  setSelectedExpositor(null);
                }

                // 3. Atualiza estados técnicos de edição
                setEstandeEditando(estandeExistente.id);
                setEstandeSelecionado(estandeExistente);
                setComponentIdEditando(estandeExistente.component_id);
                const novosItens = [];

                if (estandeExistente.area > 0 && estandeExistente.valor > 0) {
                    novosItens.push({ descricao: 'Área do espaço', valor: estandeExistente.valor, quantidade: estandeExistente.area, total: estandeExistente.valor_total });
                }

                // 2. KVA
                if (estandeExistente.calcula_kva) {
                    if (estandeExistente.kva_manual) {
                        const valorManual = parseFloat(estandeExistente.kva_valor_salvo) || 0;
                        
                        const usaM2 = estandeExistente.kva[0].cobra_por_metro;
                        const quantidade = usaM2 ? estandeExistente.area : parseFloat(estandeExistente.kva[0].quantidade);
                        const valorUnitario = quantidade > 0 ? valorManual / quantidade : 0;
                        
                        const totalCalculado = valorUnitario * quantidade;
                        
                        novosItens.push({ 
                            descricao: `KVA (Manual)`, 
                            valor: valorUnitario, 
                            quantidade: quantidade, 
                            total: totalCalculado,
                            kva_id: formData.kva_id_manual 
                        });
                    } else {
                      if (estandeExistente.kva.length > 0){ 
                        const usaM2 = estandeExistente.kva[0].cobra_por_metro;
                        const quantidade = usaM2 ? estandeExistente.area : parseFloat(estandeExistente.kva[0].quantidade);
                        const valorUnitario = quantidade > 0 ? estandeExistente.kva[0].valor / quantidade : 0;
                        const totalCalculado = valorUnitario * quantidade;

                        novosItens.push({ 
                            descricao: 'KVA (Automático)', 
                            valor: valorUnitario,
                            quantidade: quantidade,
                            total: totalCalculado,
                            kva_id: estandeExistente.kva[0].id 
                        });
                      }
                      
                    }
                }

                // 3. Estacionamento
                if (estandeExistente.tem_estacionamento) {
                  if (estandeExistente.estacionamento_manual) {
                      const quantidade = parseFloat(estandeExistente.estacionamento[0].quantidade);
                      const valorUnitario = parseFloat(estandeExistente.estacionamento_valor_manual / quantidade) || 0;
                      const totalCalculado = parseFloat(estandeExistente.estacionamento_valor_manual);

                      novosItens.push({ 
                          descricao: 'Estacionamento (Manual)', 
                          valor: valorUnitario, 
                          quantidade: quantidade, 
                          total: totalCalculado,
                          estac_id: estandeExistente.estacionamento
                      });
                  } else {
                      const quantidade = parseFloat(estandeExistente.estacionamento[0].quantidade);
                      const valorUnitario = parseFloat(estandeExistente.estacionamento[0].valor) > 0 ? parseFloat(estandeExistente.estacionamento[0].valor / quantidade) : 0;
                      const totalCalculado = parseFloat(estandeExistente.estacionamento[0].valor);

                      novosItens.push({ 
                          descricao: 'Estacionamento (Automático)', 
                          valor: valorUnitario,
                          quantidade: quantidade,
                          total: totalCalculado,
                          estac_id: estandeExistente.estacionamento[0].id 
                      });
                      
                  }
                }

                // 4. Tags / Adicionais (COM LÓGICA MANUAL)
                estandeExistente.tags.forEach(tagInfo => {
                    
                    if (tagInfo) {
                        const qtd = tagInfo.manual &&
                          tagInfo.quantidade_salva > 0 ? tagInfo.quantidade_salva : 
                          (tagInfo.cobra_por_metro ? estandeExistente.area : 1);
                        
                        let valorFinal = 0;
                        let valorUnitario = 0;
                        let desc = tagInfo.nome;

                        if (tagInfo.manual) {
                            valorUnitario = parseFloat(tagInfo.valor_salvo || 0);
                            valorFinal = parseFloat(tagInfo.valor_salvo * qtd || 0);
                            desc += ' (Manual)';
                        } else {
                            // Automático
                            valorUnitario = parseFloat(tagInfo.valor || 0);
                            valorFinal = valorUnitario * qtd;
                        }

                        novosItens.push({ 
                            descricao: desc, 
                            valor: valorUnitario, 
                            quantidade: qtd, // Se manual, qtd 1, total fixo
                            total: valorFinal,
                            tag_id: tagInfo.id
                        });
                    }
                });
                // setUltimoTipoGravado(estandeExistente.tipo_espaco_id?.toString() || '');
                setFormData({
                  ...formData,
                  feira_id: feiraId,
                  estande_id: estandeExistente.id,
                  expositor_id: estandeExistente.expositor && estandeExistente.expositor.length > 0 ? estandeExistente.expositor[0].id : null
                });

                setResumoItens(novosItens);
                setSelectedComponents([]);
                setSelectedComponents([componentId]);
                updateSelectedRegionsVisual([componentId]);
              }
              else {
                setSelectedEstande(null); // Reseta o Select de "Espaço"
                setSelectedExpositor(null); // Reseta o Select de "Expositor"
                setEstandeEditando(null);
                setEstandeSelecionado(null);
                setSelectedComponents([componentId]);
                updateSelectedRegionsVisual([componentId]);
                limparCamposEspecificos();
              }
            }
          });
      });

      updateSelectedRegionsVisual(selectedComponents);
  
    }, [mapData, estandesCadastrados, editandoMapa, modoEdicaoTexto, estandeTextoEditando, posicaoTextoTemporaria, selectedComponents, tiposEspacoFeira, termoBusca]);

    const loadEstantesCadastrados = async () => {
      try {
        const response = await fetch(`${api.API_URL}/feira/estandes/${feiraId}`, {
          method: 'GET'
        });
        const data = await response.json();
        
        setEstandesCadastrados(data.data);
        return data.data;
      } catch (err) {
        console.error("Erro ao carregar espaços:", err);
        return [];
      }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (selectedEstande === null){
          toast.error("Preencha o espaço.");
          return;
        }
     
        setIsLoading(true);
    
        try {
          const dataToSend = {
            components: selectedComponents.map(componentId => ({
              component_id: componentId,
              hash_path: componentHashes[componentId] || null
            })),
            feira_id: feiraId,
            estande_id: selectedEstande.value,
            expositor_id: selectedExpositor != null ? selectedExpositor.value : null
          };
        
        const metodo = "PUT";
        
        const url = `${api.API_URL}/feira/estande_mapa/${selectedEstande.value}`;

        const response = await fetchComAuthJson(
          url, {
            method: metodo,
            body: JSON.stringify(dataToSend)
        });

        if (!response.ok) {
          throw new Error(`Erro: ${response.status}`);
        }
        else {
          const estandes = await loadEstantesCadastrados();
          setEstandesCadastrados(estandes);
          toast.success("Espaço cadastrado com sucesso!");
          setEstandeEditando(null);
          setEstandeSelecionado(null);
          setComponentIdEditando(null);
          setSelectedEstande(null);
          setSelectedExpositor(null);
          
          setFormData({
            feira_id: feiraId,
         
          });

          setSelectedComponents([]);
          setResumoItens([]);
         
        }
        
        } catch (err) {
          console.error("Erro ao enviar dados:", err);
          setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const iniciarEdicaoTexto = () => {
      if (selectedComponents.length !== 1 || !svgRef.current || !mapData) return;

      const componentId = selectedComponents[0];

      const hashDoComponente = mapData.paths[componentId]?.hash;
      if (!hashDoComponente) {
        toast.error("Não foi possível encontrar o hash para o componente selecionado.");
        return;
      }

      const estandeSelecionado = estandesCadastrados.find(e => e.hash_path === hashDoComponente);

      if (!estandeSelecionado) {
        toast.error("Estande não encontrado nos dados cadastrados para iniciar a edição.");
        return;
      }
     
      let initialPosition;

      // Se já existe uma posição salva, usa ela
      if (estandeSelecionado.label_pos_x != null && estandeSelecionado.label_pos_y != null) {
        initialPosition = { x: estandeSelecionado.label_pos_x, y: estandeSelecionado.label_pos_y };
      } else {
        // Se não, calcula a posição central do elemento SVG
        const pathNode = svgRef.current.querySelector(`path[data-code="${componentId}"]`);
        if (pathNode) {
          const bbox = pathNode.getBBox();
          initialPosition = { x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2 };
        } else {
          initialPosition = { x: 0, y: 0 };
          toast.warn("Não foi possível determinar a posição inicial do texto.");
        }
      }

      setEstandeTextoEditando(estandeSelecionado);
      setPosicaoTextoOriginal(initialPosition);
      setPosicaoTextoTemporaria(initialPosition);
      setModoEdicaoTexto(true);
    };

    const moverTexto = (direcao) => {
      const incremento = 5; // Move 5 pixels a cada clique
      setPosicaoTextoTemporaria(prevPos => {
        switch (direcao) {
          case 'up':{
            return { ...prevPos, y: prevPos.y - incremento };
          }
          case 'down':
            return { ...prevPos, y: prevPos.y + incremento };
          case 'left':
            return { ...prevPos, x: prevPos.x - incremento };
          case 'right':
            return { ...prevPos, x: prevPos.x + incremento };
          default:
            return prevPos;
        }
      });
    };

    const handleSalvarPosicaoTexto = async () => {
      if (!estandeTextoEditando) return;

      try {
        setIsLoading(true);
        
        const response = await fetchComAuthJson(`${api.API_URL}/configuracaoFonte`, {
          method: 'POST',
          body: JSON.stringify({
            margem_x: posicaoTextoTemporaria.x,
            margem_y: posicaoTextoTemporaria.y,
            feira_id: feiraId,
            estande_id: estandeTextoEditando.id
          }),
        });

        const json = await response.json();
        if (json.status) {
          toast.success("Posição do texto salva com sucesso!");
        } else {
          toast.error("Falha ao salvar a posição do texto.");
        }

        // Atualiza os dados locais para refletir a mudança
        await carregarMapaSalvo(); // Recarrega os dados do mapa para garantir consistência

      } catch (err) {
        console.error(err);
        toast.error("Erro ao salvar a posição.");
        // Reverte para a posição original em caso de erro
        setPosicaoTextoTemporaria(posicaoTextoOriginal);
      } finally {
        setIsLoading(false);
        setModoEdicaoTexto(false);
        setEstandeTextoEditando(null);
      }
    };

    const handleCancelarEdicaoTexto = () => {
      setModoEdicaoTexto(false);
      setEstandeTextoEditando(null);
      setPathsRendered(false);
      setTimeout(() => setPathsRendered(true), 0);
    };

    return (
      <div style={{ 
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
      }}>
        
        {mapData && !modoEdicaoMapa && (
          <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
            <button
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#0d6efd",
                color: "#fff",
                border: "none",
                borderRadius: "4px"
              }}
              onClick={() => setModoEdicaoMapa(true)}
            >
              Editar Mapa
            </button>
            <button
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "4px"
          }}
          onClick={() => setShowConfirmDeleteModal(true)}
        >
          Excluir Mapa
        </button>

          </div>
        )}

        {showConfirmDeleteModal && (
          <div style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
            display: "flex", justifyContent: "center", alignItems: "center"
          }}>
            <div style={{
              backgroundColor: "#fff", padding: "2rem", borderRadius: "8px",
              maxWidth: "500px", width: "95%", textAlign: "center"
            }}>
              <h4 style={{ color: "#d32f2f" }}>Tem certeza que deseja excluir o mapa atual?</h4>
              <p>Essa ação não poderá ser desfeita.</p>

              <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1.5rem" }}>
                <button
                  onClick={() => setShowConfirmDeleteModal(false)}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px"
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleDeleteMap}
                  disabled={deletingMap}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    opacity: deletingMap ? 0.7 : 1
                  }}
                >
                  {deletingMap ? "Excluindo..." : "Sim, excluir"}
                </button>
              </div>
            </div>
          </div>
        )}

        {(!mapData || modoEdicaoMapa) && (
          <Row
            style={{
              padding: "1.5rem",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f8f9fa",
              alignItems: "flex-end",
            }}
          >
            <Col lg={4}>
              <label>Imagem de fundo do mapa:</label>
              <input
                ref={fileInputFundoRef}
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setFundoUrl(reader.result);     // preview
                    setFundoBase64(reader.result);  // payload para salvar
                  };
                  reader.readAsDataURL(file);
                }}
              />
            </Col>

            <Col lg={4}>
              <label>SVG do Mapa dos espaços:</label>
              <input
                type="file"
                label="SVG"
                accept=".svg"
                onChange={handleFileChange}
                disabled={isLoading}
              />
              {isLoading && <p style={{ marginTop: "0.5rem" }}>Processando mapa...</p>}
              {error && (
                <p style={{ color: "red", marginTop: "0.5rem" }}>
                  Erro: {error}
                </p>
              )}
            </Col>

            {modoEdicaoMapa && (
              <Col lg={4}>
                <button
                  onClick={() => {
                    setModoEdicaoMapa(false);
                  }
                }
                  style={{
                    marginTop: "1.5rem",
                    padding: "0.5rem 1rem",
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    width: "100%"
                  }}
                >
                  Cancelar
                </button>
              </Col>
            )}
          </Row>
        )}

        <Row style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start' }}>
  
          {/* Seção do Mapa */}
          {mapData ? (
            <Col sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                ref={mapContainerRef}
                style={{
                  position: "relative",
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    height: '75vh', // Alterado de 1000px para 75% da altura da tela para melhor ajuste
    backgroundColor: "#fff", // Fundo branco para não parecer vazio
    marginTop: "0px"
                }}
              >
                {/* <div style={{
  position: 'absolute',
  top: '10px',
  left: '10px',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  pointerEvents: 'none'
}}>
  <div style={{ pointerEvents: 'auto' }}>
    <Input
      type="text"
      placeholder="Buscar estande..."
      value={termoBusca}
      onChange={(e) => setTermoBusca(e.target.value)}
      size="sm"
      style={{ width: '200px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
    />
  </div>
  <div style={{ 
    display: 'flex', 
    gap: '10px', 
    fontSize: '10px', 
    color: '#666', 
    backgroundColor: 'rgba(255,255,255,0.8)',
    padding: '2px 8px',
    borderRadius: '4px',
    width: 'fit-content',
    border: '1px solid #ddd'
  }}>
    <span><strong>Lar.:</strong> {mapData.width}</span>
    <span><strong>Alt.:</strong> {mapData.height}</span>
  </div>
</div> */}
                <Row>
                  <Col sm={8}>
                  <div style={{
  position: 'absolute',
  left: '20px',
  zIndex: 10,
  width: '250px'
}}>
  <Input
    type="text"
    placeholder="🔍 Buscar estande ou expositor..."
    value={termoBusca}
    onChange={(e) => setTermoBusca(e.target.value)}
    style={{
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      border: '2px solid #0d6efd'
    }}
  />
  {termoBusca && (
    <Button 
      size="sm" 
      color="link" 
      onClick={() => setTermoBusca("")}
      style={{ position: 'absolute', right: '5px', top: '5px', color: '#666', textDecoration: 'none' }}
    >
      ✕
    </Button>
  )}
</div>
</Col>
                  <Col sm={2}>
                    <dt>Largura:</dt>
                    <dd id="svg-largura">{mapData.width}</dd>
                  </Col>
                  <Col sm={2}>
                    <dt>Altura:</dt>
                    <dd id="svg-altura">{mapData.height}</dd>
                  </Col>
                </Row>

                {/* Adicione este campo de busca antes do MapaMemoizado */}

               
                <MapaMemoizado 
                  mapData={mapData} 
                  fundoUrl={fundoUrl} 
                  ref={svgRef} // Passamos a ref para o filho
                />
              </div>
            </Col>
          ) : 
          <Col sm={6} style={{ display: 'flex' }}>
            <div style={{
                width: "100%",
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #ddd",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
                overflow: "hidden"
              }}>
                <p>Nenhum mapa carregado. Faça upload dos arquivos.</p>
            </div>
          </Col>}
          
          <Col xl={6} style={{ display: 'flex' }}>

            {/* Formulário de Configuração */}
            <div style={{
              flex: 1,
              padding: "1.5rem",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f8f9fa"
              
            }}>
              {/* {tiposEspacoFeira.length === 0 && (
                <div style={{
                  marginBottom: "1rem",
                  padding: "1rem",
                  backgroundColor: "#fff3cd",
                  border: "1px solid #ffeeba",
                  borderRadius: "6px",
                  color: "#856404"
                }}>
                  <strong>Atenção:</strong> Nenhum tipo de espaço está cadastrado para esta feira.
                  <br />
                  Cadastre pelo menos um tipo de espaço na aba <strong>Tipos de Espaços</strong> para poder adicionar espaços ao mapa.
                </div>
              )} */}

              {/* --- BOTÃO PARA INICIAR A EDIÇÃO DE TEXTO --- */}
              {!modoEdicaoTexto && selectedComponents.length === 1 && (
                <div style={{ marginBottom: "1rem" }}>
                  <button
                    type="button"
                    onClick={iniciarEdicaoTexto}
                    style={{ padding: "0.5rem 1rem", backgroundColor: "#ffc107", color: "#000", border: "none", borderRadius: "4px", width: "100%" }}
                  >
                    Configurar Posição do Texto
                  </button>
                </div>
              )}

              {/* --- PAINEL DE CONTROLE DA POSIÇÃO DO TEXTO --- */}
              {modoEdicaoTexto && (
                <Card style={{ marginBottom: '1rem', border: '2px solid #0d6efd' }}>
                  <CardHeader>
                    <h5 className="card-title mb-0">Ajustar Posição do Texto</h5>
                    <p className="text-muted mb-0">Estande: {estandeTextoEditando?.nome}</p>
                  </CardHeader>
                  <CardBody style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: '10px' }}>
                      <Button color="primary" onClick={() => moverTexto('up')}>
                        <i className="ri-arrow-up-s-line"></i> {/* Usando Remix Icon como exemplo */}
                      </Button>
                    </div>
                    <div>
                      <Button color="primary" style={{ marginRight: '10px' }} onClick={() => moverTexto('left')}>
                        <i className="ri-arrow-left-s-line"></i>
                      </Button>
                      <Button color="primary" style={{ marginLeft: '10px' }} onClick={() => moverTexto('right')}>
                        <i className="ri-arrow-right-s-line"></i>
                      </Button>
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <Button color="primary" onClick={() => moverTexto('down')}>
                        <i className="ri-arrow-down-s-line"></i>
                      </Button>
                    </div>
                    <hr />
                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '1rem' }}>
                      <Button color="success" onClick={handleSalvarPosicaoTexto} disabled={isLoading}>
                        {isLoading ? 'Salvando...' : 'Salvar'}
                      </Button>
                      <Button color="secondary" onClick={handleCancelarEdicaoTexto}>
                        Cancelar
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              )}
              
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col lg={6}>
                      <div className="mb-3">
                          <Label className="form-label">Espaço</Label>
                          <Select value={selectedEstande} onChange={setSelectedEstande} options={EstandeOpcoes} placeholder="Selecione..."/>
                      </div>
                  </Col>
                
                  <Col lg={6}>
                      <div className="mb-3">
                          <Label className="form-label">Expositor</Label>
                          <Select value={selectedExpositor} onChange={setSelectedExpositor} options={ExpositorOpcoes} placeholder="Selecione..."/>
                      </div>
                  </Col>
                </Row>

                {estandeEditando && (
                  <Card className="mb-3 border-light shadow-sm">
                    <CardHeader className="bg-white py-2">
                      <h6 className="mb-0 text-primary">Detalhes do Espaço: {estandeSelecionado.nome}</h6>
                    </CardHeader>
                    <CardBody className="py-2">
                      <Row className="mb-2">
                        <Col md={4}>
                          <small className="text-muted d-block">Tipo:</small>
                          <strong>{estandeSelecionado.tipo_espaco_nome || 'N/A'}</strong>
                        </Col>
                        <Col md={4}>
                          <small className="text-muted d-block">Área Total:</small>
                          <strong>{estandeSelecionado.area} m²</strong>
                        </Col>
                        <Col md={4}>
                          <small className="text-muted d-block">Dimensões (L x C):</small>
                          <strong>{estandeSelecionado.largura}m x {estandeSelecionado.comprimento}m</strong>
                        </Col>
                      </Row>
                      
                      <Row className="mb-2">
                        <Col md={4}>
                          <small className="text-muted d-block">Pé Direito (Mín/Máx):</small>
                          <strong>{estandeSelecionado.altura_minima}m / {estandeSelecionado.altura_maxima}m</strong>
                        </Col>
                        <Col md={4}>
                          <small className="text-muted d-block">Valor m²:</small>
                          <strong>R$ {parseFloat(estandeSelecionado.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong>
                        </Col>
                        <Col md={4}>
                          <small className="text-muted d-block">Status:</small>
                          <span className={`badge ${(estandeSelecionado.status_reserva_id === 3 || estandeSelecionado.status_reserva_id === 2) && estandeSelecionado.expositor?.[0]?.nome ? 'bg-warning' : 'bg-success'}`}>
                            {(estandeSelecionado.status_reserva_id === 3 || estandeSelecionado.status_reserva_id === 2) && estandeSelecionado.expositor?.[0]?.nome  ? 'Vendido/Reservado' : 'Livre'}
                          </span>
                        </Col>
                      </Row>

                      {/* Prévia das Imagens */}
                      {estandeSelecionado.imagens && estandeSelecionado.imagens.length > 0 && (
                        <div className="mt-2 border-top pt-2">
                          <small className="text-muted d-block mb-2">Imagens do Local:</small>
                          <div className="d-flex flex-wrap gap-2">
                            {estandeSelecionado.imagens.map((img, index) => (
                              <div key={index} style={{ position: 'relative' }}>
                                <img
                                  src={img.url || img.preview}
                                  alt={`Estande ${index}`}
                                  style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                )}
                
                {estandeEditando && (
                  <div className="table-responsive" style={{ minHeight: '200px important!' }}>
                    <table className="table table-bordered table-primary">
                      <thead>
                        <tr>
                          <th>Descrição</th>
                          <th>Valor</th>
                          <th>Quantidade</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resumoItens.map((item, index) => (
                          <tr key={index}>
                            <td>{item.descricao}</td>
                            <td>R$ {item.valor ? item.valor.toFixed(2) : ''}</td>
                            <td>{item.quantidade}</td>
                            <td>R$ {item.total ? item.total.toFixed(2) : ''}</td>
                          </tr>
                        ))}
                        <tr style={{ fontWeight: "bold" }}>
                          <td colSpan="3">Valor Total Espaço</td>
                          <td>R$ {resumoItens.reduce((acc, item) => acc + item.total, 0).toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isLoading || selectedComponents.length === 0}
                  style={{
                    padding: "0.75rem 1.5rem",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    opacity: (isLoading || selectedComponents.length === 0) ? 0.6 : 1
                  }}
                >
                  {isLoading ? "Enviando..." : "Salvar Configuração"}
                </button>

                {selectedComponents.length === 0 && (
                  <p style={{ color: "#ff4444", marginTop: "0.5rem" }}>
                    Selecione pelo menos um componente no mapa
                  </p>
                )}
              </form>
            </div>

          </Col>
        </Row>

        {showConfirmMapaModal && (
          <div style={{
            position: "fixed", 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", 
            zIndex: 9999,
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center",
            padding: "1rem"
          }}>
            <div style={{
              backgroundColor: "#fff", 
              padding: "1.5rem", 
              borderRadius: "8px",
              maxWidth: "900px", 
              width: "95%",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column"
            }}>
              <div style={{overflowY: "auto", flex: 1}}>
                <h4 style={{ 
                  marginBottom: "1rem", 
                  color: "#d32f2f",
                  fontSize: "1.25rem"
                }}>
                  ⚠️ ATENÇÃO, IDENTIFICAMOS INCONSISTÊNCIA NO SEU ARQUIVO
                </h4>
                
                <p style={{marginBottom: "1rem"}}>
                  Alguns componentes foram identificados como novos, outros foram perdidos e alguns foram mantidos. Confira abaixo:
                </p>
                
                {/* Seção de resumo */}
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "0.5rem",
                  marginBottom: "1rem"
                }}>
                  <div className="badge bg-success-subtle text-success" style={{padding: "0.5rem"}}>
                    Novos: {componentesNovos.length}
                  </div>
                  <div className="badge bg-warning-subtle text-warning" style={{padding: "0.5rem"}}>
                    Perdidos sem cadastro: {componentesPerdidosSemCadastro.length}
                  </div>
                  <div className="badge bg-danger-subtle text-danger" style={{padding: "0.5rem"}}>
                    Perdidos com cadastro: {componentesPerdidosPendentes.length}
                  </div>
                  <div className="badge bg-info-subtle text-info" style={{padding: "0.5rem"}}>
                    Mantidos: {componentesMantidos.length}
                  </div>
                </div>
                
                {/* Espaços com vínculo - com scroll se necessário */}
                {estandesComVinculo.length > 0 && (
                  <div style={{marginBottom: "1rem"}}>
                    <p className="badge bg-danger-subtle text-danger text-uppercase" style={{
                      display: "block",
                      marginBottom: "0.5rem",
                      padding: "0.5rem",
                      width: "100%"
                    }}>
                      Espaços com Reserva ou Venda: {estandesComVinculo.length}
                    </p>
                    <div style={{
                      maxHeight: "100px",
                      overflowY: "auto",
                      border: "1px solid #eee",
                      padding: "0.5rem",
                      fontSize: "0.9rem"
                    }}>
                      {estandesComVinculo.map(item => item.nome).join(', ') || "Nenhum"}
                    </div>
                  </div>
                )}
                
                {/* Tabela comparativa */}
                <div style={{ 
                  maxHeight: "300px", 
                  overflowY: "auto", 
                  border: "1px solid #ddd",
                  marginBottom: "1rem"
                }}>
                  <table style={{ 
                    width: "100%", 
                    borderCollapse: "collapse", 
                    textAlign: "left",
                    fontSize: "0.9rem"
                  }}>
                    <thead style={{ 
                      position: "sticky", 
                      top: 0, 
                      backgroundColor: "#f8f9fa", 
                      zIndex: 1 
                    }}>
                      <tr>
                        <th style={{ 
                          padding: "0.75rem", 
                          border: "1px solid #ddd", 
                          backgroundColor: "#fff8e1",
                          color: "#856404"
                        }}>
                          ❌ Perdidos com cadastro
                        </th>
                        <th style={{ 
                          padding: "0.75rem", 
                          border: "1px solid #ddd", 
                          backgroundColor: "#e8f5e9",
                          color: "#2e7d32"
                        }}>
                          ✅ Mantidos
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from({ 
                        length: Math.max(
                          componentesPerdidosPendentes.length,
                          componentesMantidos.length
                        ) 
                      }).map((_, i) => (
                        <tr key={i}>
                          <td style={{ 
                            padding: "0.75rem", 
                            border: "1px solid #ddd",
                            backgroundColor: i % 2 === 0 ? "#fff" : "#fff8e133"
                          }}>
                            {componentesPerdidosPendentes[i]?.nome || componentesPerdidosPendentes[i]?.component_id || ""}
                          </td>
                          <td style={{ 
                            padding: "0.75rem", 
                            border: "1px solid #ddd",
                            backgroundColor: i % 2 === 0 ? "#fff" : "#e8f5e933"
                          }}>
                            {componentesMantidos[i] || ""}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <p style={{ marginBottom: "1rem", fontSize: "0.95rem" }}>
                  Deseja continuar e carregar este novo mapa? Os espaços perdidos não serão renderizados, mas continuam salvos no banco.
                </p>
              </div>
              
              {/* Botões de ação */}
              <div style={{ 
                display: "flex", 
                justifyContent: "flex-end", 
                gap: "1rem",
                paddingTop: "1rem",
                borderTop: "1px solid #eee"
              }}>
                <button
                  onClick={() => {
                    setShowConfirmMapaModal(false);
                    setNovoMapaPendente(null);
                    setComponentesPerdidosPendentes([]);
                    setEstandesComVinculo([]);
                    setComponentesPerdidosSemCadastro([]);
                    setComponentesMantidos([]);
                    setComponentesNovos([]);
                  }}
                  style={{
                    padding: "0.5rem 1.25rem",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    transition: "background-color 0.2s"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e0e0e0"}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
                >
                  Cancelar
                </button>
                <button
                  onClick={confirmarSalvarNovoMapa}
                  style={{
                    padding: "0.5rem 1.25rem",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    transition: "background-color 0.2s"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#3d8b40"}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#4caf50"}
                >
                  Sim, continuar
                </button>
              </div>
            </div>
          </div>
        )}
  
        {showConfirmResetModal && (
          <div style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999
          }}>
            <div style={{
              background: "#fff", padding: "2rem", borderRadius: "8px",
              maxWidth: "400px", textAlign: "center", boxShadow: "0 0 15px rgba(0,0,0,0.3)"
            }}>
              <p>Você alterou o tipo de espaço. Deseja limpar os dados atuais do cadastro?</p>
              <div style={{ marginTop: "1.5rem", display: "flex", justifyContent: "space-between" }}>
                <button onClick={limparCamposEspecificos} style={{ background: "#e53935", color: "#fff", padding: "0.5rem 1rem", border: "none", borderRadius: "4px" }}>
                  Sim, limpar
                </button>
                <button onClick={manterCampos} style={{ background: "#4caf50", color: "#fff", padding: "0.5rem 1rem", border: "none", borderRadius: "4px" }}>
                  Não, manter dados
                </button>
              </div>
            </div>
          </div>
        )}

    </div>
  );
};

export default TelaMapaUpload;
